<template>
  <div>
    <!--begin::Sidebar-->
    <div id="kt_app_sidebar" class="app-sidebar flex-column" data-kt-drawer="true" data-kt-drawer-name="app-sidebar" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="225px" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle">
      <!--begin::Logo-->
      <div class="app-sidebar-logo px-6" id="kt_app_sidebar_logo">
        <!--begin::Logo image-->
        <router-link to="/">
          <img alt="Logo" src="/images/layout/logo-nova-pixel.png" class="h-45px app-sidebar-logo-default" />
          <img alt="Logo" src="/images/favicon/favicon-60.png" class="h-35px app-sidebar-logo-minimize">
        </router-link>
        <!--end::Logo image-->
        <!--begin::Sidebar toggle-->
        <div
          id="kt_app_sidebar_toggle"
          class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
          :class="{
            active: isSidebarClosed
          }"
          data-kt-toggle="true"
          data-kt-toggle-state="active"
          data-kt-toggle-target="body"
          data-kt-toggle-name="app-sidebar-minimize"
          @click="toggleSidebar"
        >
          <!--begin::Svg Icon | path: icons/duotune/arrows/arr079.svg-->
          <span class="svg-icon svg-icon-2 rotate-180">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5" d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z" fill="currentColor" />
              <path d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z" fill="currentColor" />
            </svg>
          </span>
          <!--end::Svg Icon-->
        </div>
        <!--end::Sidebar toggle-->
      </div>
      <!--end::Logo-->
      <!--begin::sidebar menu-->
      <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
        <!--begin::Menu wrapper-->
        <div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper hover-scroll-overlay-y my-5" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer" data-kt-scroll-wrappers="#kt_app_sidebar_menu" data-kt-scroll-offset="5px" data-kt-scroll-save-state="true">
          <!--begin::Menu-->
          <div class="menu menu-column menu-rounded menu-sub-indention px-3" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false">

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('routine')
              }"
              @click="toggleItem('routine')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/kt-products/docs/metronic/html/releases/2022-10-09-043348/core/html/src/media/icons/duotune/general/gen014.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"/>
                  <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"/>
                  <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Tarefas rotineiras</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('routine')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'pixels.pending.index', query: { status: 'PENDING', platform: 'GOOGLE' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Criação de pixels DV360</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'pixels.pending.index', query: { status: 'PENDING', platform: 'YAHOO', objective: 'RETARGETING' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Criação de pixels YAHOO</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'creatives.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Check de criativos</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'campaigns.index', query: { platform: 'MGID' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Campanhas MGID</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'campaigns.index', query: { status: 'PENDING', platform: 'GOOGLE', type: 'YOUTUBE' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Campanhas YouTube</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'campaigns.index', query: { status: 'PENDING', platform: 'GOOGLE', type: 'AUDIO' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Campanhas Spotify</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--end:Menu item-->
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'invoices.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Pagamentos</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--end:Menu item-->
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('companies')
              }"
              @click="toggleItem('companies')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/keenthemes/metronic/docs/core/html/src/media/icons/duotune/finance/fin001.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="currentColor"/>
                  <path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Empresas</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('companies')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'companies.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de empresas</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('advertisers')
              }"
              @click="toggleItem('advertisers')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/kt-products/docs/metronic/html/releases/2023-01-30-131017/core/html/src/media/icons/duotune/general/gen003.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.0079 2.6L15.7079 7.2L21.0079 8.4C21.9079 8.6 22.3079 9.7 21.7079 10.4L18.1079 14.4L18.6079 19.8C18.7079 20.7 17.7079 21.4 16.9079 21L12.0079 18.8L7.10785 21C6.20785 21.4 5.30786 20.7 5.40786 19.8L5.90786 14.4L2.30785 10.4C1.70785 9.7 2.00786 8.6 3.00786 8.4L8.30785 7.2L11.0079 2.6C11.3079 1.8 12.5079 1.8 13.0079 2.6Z" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Anunciantes</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('advertisers')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'advertisers.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de anunciantes</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'advertisers.index', query: { status: 'INACTIVE' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Anunciantes Inativos</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('audiences')
              }"
              @click="toggleItem('audiences')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">

                <span class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 512">
                    <path fill-rule="nonzero" d="M256 0c70.69 0 134.69 28.66 181.02 74.98C483.35 121.31 512 185.31 512 256c0 70.68-28.66 134.69-74.98 181.02C390.69 483.35 326.69 512 256 512c-70.69 0-134.69-28.66-181.02-74.98C28.66 390.69 0 326.69 0 256c0-70.69 28.65-134.69 74.98-181.02C121.31 28.66 185.32 0 256 0zm-18.32 265.37c-4.99-4.43-11.25-8.26-12.1-17.47l-.53.01c-1.24-.02-2.43-.3-3.55-.94-1.78-1.02-3.04-2.76-3.89-4.73-1.79-4.13-3.21-14.99 1.31-18.09l-.85-.56-.1-1.21c-.17-2.18-.21-4.83-.26-7.61-.16-10.21-.37-22.58-8.58-25.06l-3.52-1.07 2.32-2.87c6.63-8.2 13.56-15.36 20.56-20.87 7.9-6.22 15.94-10.37 23.81-11.57 8.08-1.22 15.91.64 23.15 6.48 2.13 1.73 4.21 3.8 6.21 6.24 7.72.74 14.03 4.9 18.54 10.83 2.69 3.55 4.73 7.73 6.03 12.19 1.3 4.44 1.86 9.15 1.62 13.8-.44 8.33-3.48 16.46-9.62 22.39 1.08.03 2.1.28 3 .76 3.42 1.84 3.53 5.81 2.63 9.15-.89 2.79-2.02 6.02-3.08 8.74-1.3 3.66-3.19 4.35-6.85 3.96-.18 8.95-6.73 12.62-12.33 17.85 13.68 25.55 71.71 19.25 71.71 70.04H165.82c0-50.79 56.69-43.81 71.94-70.37l-.08-.02zm-91.2 2.92a26.08 26.08 0 0 1-2.11-2.58c-1.55-2.13-3.01-4.36-4.41-6.59l-7-11.14c-2.66-3.87-4.05-7.41-4.05-10.22 0-2.8 1.58-6.45 4.75-7.27-.26-4.19-.42-8.45-.42-12.66 0-2.5.05-5.02.14-7.49.14-1.56.42-3.11.84-4.62a26.624 26.624 0 0 1 11.9-15.11 30.81 30.81 0 0 1 6.45-3.08c4.07-1.54 2.11-7.75 6.59-7.84 10.47-.28 27.68 8.69 34.39 15.96a26.508 26.508 0 0 1 6.86 17.21l-.42 18.33c1.86.46 3.31 1.91 3.78 3.77.55 2.25 0 5.32-1.96 9.66 0 .14-.15.14-.15.29l-7.98 13.15c-1.81 2.97-3.68 6.01-5.78 8.79-2.49 3.34-4.54 2.74-2.41 5.93 1.78 2.45 3.85 4.42 6.13 6.08-16.51 8.14-31.37 19.2-34.59 43.43H94.65c0-41.78 37.25-28.51 52.51-49.51 1.76-2.58 1.29-2.39-.68-4.49zm182.81 1.88c-.73-.78-1.41-1.62-2.03-2.49-1.5-2.06-2.91-4.2-4.26-6.35l-6.76-10.76c-1.62-2.35-2.75-4.58-3.36-6.58.47-1.34.93-2.68 1.39-4.07.2-.49.38-1 .51-1.52.36-1.31.62-2.69.77-4.12.41-.25.87-.45 1.37-.58-.25-4.05-.41-8.16-.41-12.23 0-1.25.02-2.51.04-3.76 1.28-3.76 2.06-7.69 2.39-11.66 2.19-4.49 5.66-8.27 10-10.85 1.95-1.22 4.05-2.23 6.23-2.97 3.93-1.48 2.03-7.48 6.36-7.57 10.1-.26 26.71 8.39 33.19 15.41a25.67 25.67 0 0 1 6.62 16.61l-.41 17.69c1.79.44 3.2 1.84 3.65 3.64.54 2.17 0 5.13-1.9 9.32 0 .14-.13.14-.13.28l-7.7 12.69c-1.75 2.87-3.55 5.8-5.58 8.49-2.41 3.22-4.39 2.64-2.34 5.72 14.75 20.26 50.42 7.48 50.42 47.78h-54.93c-3.34-24.68-18.94-35.85-35.89-44.05 1.26-1.11 2.41-2.34 3.42-3.73 1.69-2.49 1.25-2.31-.66-4.34zM275.03 35.13V73.2h-33.35V34.78c-55.51 3.54-105.47 27.51-142.43 64.47-37.61 37.61-61.77 88.67-64.64 145.36h45.2v33.34H35.4c5.15 52.45 28.59 99.55 63.85 134.8 36.96 36.97 86.92 60.94 142.43 64.47v-32.64h33.35v32.29c53.62-4.56 101.81-28.21 137.72-64.12 35.26-35.25 58.7-82.35 63.85-134.8h-39.7v-33.34h40.49c-2.87-56.69-27.03-107.75-64.64-145.36-35.91-35.91-84.1-59.56-137.72-64.12z"/>
                  </svg>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Audiências</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('audiences')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'audiences.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de audiências</span>
                    </router-link>
                  </div>
                  <!--end:Menu link-->
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'audiences.create' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Gerenciar audiências</span>
                    </router-link>
                  </div>
                  <!--end:Menu link-->
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('campaigns')
              }"
              @click="toggleItem('campaigns')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/kt-products/docs/metronic/html/releases/2023-01-30-131017/core/html/src/media/icons/duotune/communication/com012.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3" d="M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z" fill="currentColor"/>
                  <rect x="6" y="12" width="7" height="2" rx="1" fill="currentColor"/>
                  <rect x="6" y="7" width="12" height="2" rx="1" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Campanhas</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('campaigns')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'campaigns.create' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Criar campanha manual</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'campaigns.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de campanhas</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'campaigns.index', query: { watcher_is_alert: '1' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Campanhas em Alerta</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'campaigns.import.mgid' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Importar campanhas MGID</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'campaigns.import.dv360' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Importar campanhas DV360</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('creatives')
              }"
              @click="toggleItem('creatives')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/kt-products/docs/metronic/html/releases/2023-01-30-131017/core/html/src/media/icons/duotune/art/art008.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3" d="M16.163 17.55C17.0515 16.6633 17.6785 15.5488 17.975 14.329C18.2389 13.1884 18.8119 12.1425 19.631 11.306L12.694 4.36902C11.8574 5.18796 10.8115 5.76088 9.67099 6.02502C8.15617 6.3947 6.81277 7.27001 5.86261 8.50635C4.91245 9.74268 4.41238 11.266 4.44501 12.825C4.46196 13.6211 4.31769 14.4125 4.0209 15.1515C3.72412 15.8905 3.28092 16.5617 2.71799 17.125L2.28699 17.556C2.10306 17.7402 1.99976 17.9897 1.99976 18.25C1.99976 18.5103 2.10306 18.7598 2.28699 18.944L5.06201 21.719C5.24614 21.9029 5.49575 22.0062 5.75601 22.0062C6.01627 22.0062 6.26588 21.9029 6.45001 21.719L6.88101 21.288C7.44427 20.725 8.11556 20.2819 8.85452 19.9851C9.59349 19.6883 10.3848 19.5441 11.181 19.561C12.1042 19.58 13.0217 19.4114 13.878 19.0658C14.7343 18.7201 15.5116 18.2046 16.163 17.55Z" fill="currentColor"/>
                  <path d="M19.631 11.306L12.694 4.36902L14.775 2.28699C14.9591 2.10306 15.2087 1.99976 15.469 1.99976C15.7293 1.99976 15.9789 2.10306 16.163 2.28699L21.713 7.83704C21.8969 8.02117 22.0002 8.27075 22.0002 8.53101C22.0002 8.79126 21.8969 9.04085 21.713 9.22498L19.631 11.306ZM13.041 10.959C12.6427 10.5604 12.1194 10.3112 11.5589 10.2532C10.9985 10.1952 10.4352 10.332 9.96375 10.6405C9.4923 10.949 9.14148 11.4105 8.97034 11.9473C8.79919 12.4841 8.81813 13.0635 9.02399 13.588L2.98099 19.631L4.36899 21.019L10.412 14.975C10.9364 15.1816 11.5161 15.2011 12.0533 15.0303C12.5904 14.8594 13.0523 14.5086 13.361 14.037C13.6697 13.5654 13.8065 13.0018 13.7482 12.4412C13.6899 11.8805 13.4401 11.357 13.041 10.959Z" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Criativos</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('creatives')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'creatives.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de criativos</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('coupons')
              }"
              @click="toggleItem('coupons')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/kt-products/docs/metronic/html/releases/2023-01-30-131017/core/html/src/media/icons/duotune/ecommerce/ecm003.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3" d="M18 22H6C5.4 22 5 21.6 5 21V8C6.6 6.4 7.4 5.6 9 4H15C16.6 5.6 17.4 6.4 19 8V21C19 21.6 18.6 22 18 22ZM12 5.5C11.2 5.5 10.5 6.2 10.5 7C10.5 7.8 11.2 8.5 12 8.5C12.8 8.5 13.5 7.8 13.5 7C13.5 6.2 12.8 5.5 12 5.5Z" fill="currentColor"/>
                  <path d="M12 7C11.4 7 11 6.6 11 6V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V6C13 6.6 12.6 7 12 7ZM15.1 10.6C15.1 10.5 15.1 10.4 15 10.3C14.9 10.2 14.8 10.2 14.7 10.2C14.6 10.2 14.5 10.2 14.4 10.3C14.3 10.4 14.3 10.5 14.2 10.6L9 19.1C8.9 19.2 8.89999 19.3 8.89999 19.4C8.89999 19.5 8.9 19.6 9 19.7C9.1 19.8 9.2 19.8 9.3 19.8C9.5 19.8 9.6 19.7 9.8 19.5L15 11.1C15 10.8 15.1 10.7 15.1 10.6ZM11 11.6C10.9 11.3 10.8 11.1 10.6 10.8C10.4 10.6 10.2 10.4 10 10.3C9.8 10.2 9.50001 10.1 9.10001 10.1C8.60001 10.1 8.3 10.2 8 10.4C7.7 10.6 7.49999 10.9 7.39999 11.2C7.29999 11.6 7.2 12 7.2 12.6C7.2 13.1 7.3 13.5 7.5 13.9C7.7 14.3 7.9 14.5 8.2 14.7C8.5 14.9 8.8 14.9 9.2 14.9C9.8 14.9 10.3 14.7 10.6 14.3C11 13.9 11.1 13.3 11.1 12.5C11.1 12.3 11.1 11.9 11 11.6ZM9.8 13.8C9.7 14.1 9.5 14.2 9.2 14.2C9 14.2 8.8 14.1 8.7 14C8.6 13.9 8.5 13.7 8.5 13.5C8.5 13.3 8.39999 13 8.39999 12.6C8.39999 12.2 8.4 11.9 8.5 11.7C8.5 11.5 8.6 11.3 8.7 11.2C8.8 11.1 9 11 9.2 11C9.5 11 9.7 11.1 9.8 11.4C9.9 11.7 10 12 10 12.6C10 13.2 9.9 13.6 9.8 13.8ZM16.5 16.1C16.4 15.8 16.3 15.6 16.1 15.4C15.9 15.2 15.7 15 15.5 14.9C15.3 14.8 15 14.7 14.6 14.7C13.9 14.7 13.4 14.9 13.1 15.3C12.8 15.7 12.6 16.3 12.6 17.1C12.6 17.6 12.7 18 12.9 18.4C13.1 18.7 13.3 19 13.6 19.2C13.9 19.4 14.2 19.5 14.6 19.5C15.2 19.5 15.7 19.3 16 18.9C16.4 18.5 16.5 17.9 16.5 17.1C16.7 16.8 16.6 16.4 16.5 16.1ZM15.3 18.4C15.2 18.7 15 18.8 14.7 18.8C14.4 18.8 14.2 18.7 14.1 18.4C14 18.1 13.9 17.7 13.9 17.2C13.9 16.8 13.9 16.5 14 16.3C14.1 16.1 14.1 15.9 14.2 15.8C14.3 15.7 14.5 15.6 14.7 15.6C15 15.6 15.2 15.7 15.3 16C15.4 16.2 15.5 16.6 15.5 17.2C15.5 17.7 15.4 18.1 15.3 18.4Z" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Cupons</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('coupons')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'coupons.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de cupons</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'coupons.create' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Criar cupom</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('orders')
              }"
              @click="toggleItem('orders')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/kt-products/docs/metronic/html/releases/2023-03-24-172858/core/html/src/media/icons/duotune/finance/fin010.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3" d="M12.5 22C11.9 22 11.5 21.6 11.5 21V3C11.5 2.4 11.9 2 12.5 2C13.1 2 13.5 2.4 13.5 3V21C13.5 21.6 13.1 22 12.5 22Z" fill="currentColor"/>
                  <path d="M17.8 14.7C17.8 15.5 17.6 16.3 17.2 16.9C16.8 17.6 16.2 18.1 15.3 18.4C14.5 18.8 13.5 19 12.4 19C11.1 19 10 18.7 9.10001 18.2C8.50001 17.8 8.00001 17.4 7.60001 16.7C7.20001 16.1 7 15.5 7 14.9C7 14.6 7.09999 14.3 7.29999 14C7.49999 13.8 7.80001 13.6 8.20001 13.6C8.50001 13.6 8.69999 13.7 8.89999 13.9C9.09999 14.1 9.29999 14.4 9.39999 14.7C9.59999 15.1 9.8 15.5 10 15.8C10.2 16.1 10.5 16.3 10.8 16.5C11.2 16.7 11.6 16.8 12.2 16.8C13 16.8 13.7 16.6 14.2 16.2C14.7 15.8 15 15.3 15 14.8C15 14.4 14.9 14 14.6 13.7C14.3 13.4 14 13.2 13.5 13.1C13.1 13 12.5 12.8 11.8 12.6C10.8 12.4 9.99999 12.1 9.39999 11.8C8.69999 11.5 8.19999 11.1 7.79999 10.6C7.39999 10.1 7.20001 9.39998 7.20001 8.59998C7.20001 7.89998 7.39999 7.19998 7.79999 6.59998C8.19999 5.99998 8.80001 5.60005 9.60001 5.30005C10.4 5.00005 11.3 4.80005 12.3 4.80005C13.1 4.80005 13.8 4.89998 14.5 5.09998C15.1 5.29998 15.6 5.60002 16 5.90002C16.4 6.20002 16.7 6.6 16.9 7C17.1 7.4 17.2 7.69998 17.2 8.09998C17.2 8.39998 17.1 8.7 16.9 9C16.7 9.3 16.4 9.40002 16 9.40002C15.7 9.40002 15.4 9.29995 15.3 9.19995C15.2 9.09995 15 8.80002 14.8 8.40002C14.6 7.90002 14.3 7.49995 13.9 7.19995C13.5 6.89995 13 6.80005 12.2 6.80005C11.5 6.80005 10.9 7.00005 10.5 7.30005C10.1 7.60005 9.79999 8.00002 9.79999 8.40002C9.79999 8.70002 9.9 8.89998 10 9.09998C10.1 9.29998 10.4 9.49998 10.6 9.59998C10.8 9.69998 11.1 9.90002 11.4 9.90002C11.7 10 12.1 10.1 12.7 10.3C13.5 10.5 14.2 10.7 14.8 10.9C15.4 11.1 15.9 11.4 16.4 11.7C16.8 12 17.2 12.4 17.4 12.9C17.6 13.4 17.8 14 17.8 14.7Z" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Financeiro</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('orders')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'orders.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de pagamentos</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'insertion.orders.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de PI</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'nfse.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Notas fiscais</span>
                    </router-link>
                    <!--end:Menu link-->
                    <!--begin:Menu item-->
                    <div class="menu-item">
                      <!--begin:Menu link-->
                      <router-link class="menu-link" :to="{ name: 'nfse.index', query: { nfse_approval: 'PENDING' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                        <span class="menu-title">Notas fiscais pendentes</span>
                      </router-link>
                      <!--end:Menu link-->
                    </div>
                    <!--begin:Menu item-->
                    <div class="menu-item">
                      <!--begin:Menu link-->
                      <router-link class="menu-link" :to="{ name: 'nfse.index', query: { nfse_approval: 'REFUSED' } }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                        <span class="menu-title">Notas fiscais recusadas</span>
                      </router-link>
                      <!--end:Menu link-->
                    </div>
                  </div>
                </div>
              </VueSlideToggle>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('insertion-orders')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'orders.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de pagamentos</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'insertion.orders.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de PI</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('orders-claim')
              }"
              @click="toggleItem('orders-claim')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/keenthemes/metronic/docs/core/html/src/media/icons/duotune/finance/fin006.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                  <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Comercial</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('orders-claim')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'claim.sales.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Reinvidicar vendas</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'order.claims.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Reinividicações</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'my.sales.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Minhas vendas</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'commissions.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Comissões</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('reports')
              }"
              @click="toggleItem('reports')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/kt-products/docs/metronic/html/releases/2022-10-09-043348/core/html/src/media/icons/duotune/general/gen032.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="8" y="9" width="3" height="10" rx="1.5" fill="currentColor"/>
                  <rect opacity="0.5" x="13" y="5" width="3" height="14" rx="1.5" fill="currentColor"/>
                  <rect x="18" y="11" width="3" height="8" rx="1.5" fill="currentColor"/>
                  <rect x="3" y="13" width="3" height="6" rx="1.5" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Relatórios</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('reports')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'reports.campaign-list.show' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Relatório de campanhas</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'reports.financial.show' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Relatório financeiro</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'reports.revenue.show' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Relatório de receitas</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'reports.spending.show' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Relatório de gastos</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'reports.test-status.show' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Relatório de status dos testes</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'reports.users.show' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Relatório de usuários</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'reports.commission' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Relatório de comissões a pagar</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div
              data-kt-menu-trigger="click"
              class="menu-item menu-accordion"
              :class="{
                'hover show': checkIfItemIsOpen('users')
              }"
              @click="toggleItem('users')"
            >
              <!--begin:Menu link-->
              <span class="menu-link">
                <span class="menu-icon">
                  <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/kt-products/docs/metronic/html/releases/2023-01-30-131017/core/html/src/media/icons/duotune/communication/com014.svg-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.0173 9H15.3945C14.2833 9 13.263 9.61425 12.7431 10.5963L12.154 11.7091C12.0645 11.8781 12.1072 12.0868 12.2559 12.2071L12.6402 12.5183C13.2631 13.0225 13.7556 13.6691 14.0764 14.4035L14.2321 14.7601C14.2957 14.9058 14.4396 15 14.5987 15H18.6747C19.7297 15 20.4057 13.8774 19.912 12.945L18.6686 10.5963C18.1487 9.61425 17.1285 9 16.0173 9Z" fill="currentColor"/>
                  <rect opacity="0.3" x="14" y="4" width="4" height="4" rx="2" fill="currentColor"/>
                  <path d="M4.65486 14.8559C5.40389 13.1224 7.11161 12 9 12C10.8884 12 12.5961 13.1224 13.3451 14.8559L14.793 18.2067C15.3636 19.5271 14.3955 21 12.9571 21H5.04292C3.60453 21 2.63644 19.5271 3.20698 18.2067L4.65486 14.8559Z" fill="currentColor"/>
                  <rect opacity="0.3" x="6" y="5" width="6" height="6" rx="3" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Usuários</span>
                <span class="menu-arrow"></span>
              </span>
              <!--end:Menu link-->
              <VueSlideToggle
                :open="checkIfItemIsOpen('users')"
                tag="div"
                :duration="500"
              >
                <!--begin:Menu sub-->
                <div class="menu-sub menu-sub-accordion show">
                  <!--begin:Menu item-->
                  <div class="menu-item">
                    <!--begin:Menu link-->
                    <router-link class="menu-link" :to="{ name: 'users.index' }">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Lista de usuários</span>
                    </router-link>
                    <!--end:Menu link-->
                  </div>
                </div>
              </VueSlideToggle>
            </div> <!-- END MENU ITEM -->

            <!--begin:Menu item-->
            <div class="menu-item">
              <!--begin:Menu link-->
              <router-link class="menu-link" :to="{ name: 'change-history.index' }">
                <span class="menu-icon">
                  <!--begin::Svg Icon-->
                  <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.3" d="M14 3V21H10V3C10 2.4 10.4 2 11 2H13C13.6 2 14 2.4 14 3ZM7 14H5C4.4 14 4 14.4 4 15V19C4 19.6 4.4 20 5 20H7C7.6 20 8 19.6 8 19V15C8 14.4 7.6 14 7 14ZM7 3H5C4.4 3 4 3.4 4 4V8C4 8.6 4.4 9 5 9H7C7.6 9 8 8.6 8 8V4C8 3.4 7.6 3 7 3ZM19 9H17C16.4 9 16 9.4 16 10V14C16 14.6 16.4 15 17 15H19C19.6 15 20 14.6 20 14V10C20 9.4 19.6 9 19 9Z" fill="currentColor"/>
                  <path d="M22 8C22 7.4 21.6 7 21 7H19C18.4 7 18 7.4 18 8V12C18 12.6 18.4 13 19 13H21C21.6 13 22 12.6 22 12V8ZM22 15C22 14.4 21.6 14 21 14H19C18.4 14 18 14.4 18 15V19C18 19.6 18.4 20 19 20H21C21.6 20 22 19.6 22 19V15ZM10 8C10 7.4 9.6 7 9 7H7C6.4 7 6 7.4 6 8V12C6 12.6 6.4 13 7 13H9C9.6 13 10 12.6 10 12V8ZM10 15C10 14.4 9.6 14 9 14H7C6.4 14 6 14.4 6 15V19C6 19.6 6.4 20 7 20H9C9.6 20 10 19.6 10 19V15Z" fill="currentColor"/>
                  </svg>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <span class="menu-title">Histórico de alterações</span>
              </router-link>
              <!--end:Menu link-->
            </div> <!-- END MENU ITEM -->

          </div>
          <!--end::Menu-->
        </div>
        <!--end::Menu wrapper-->
      </div>
      <!--end::sidebar menu-->
      <!--begin::Footer-->
      <div class="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6" id="kt_app_sidebar_footer">
      </div>
      <!--end::Footer-->
    </div>
    <!--end::Sidebar-->
  </div>
</template>

<script>

import { VueSlideToggle } from 'vue-slide-toggle'

export default {
  name: 'TheSidebar',
  components: {
    VueSlideToggle
  },
  data () {
    return {
      isSidebarClosed: false,
      open: []
    }
  },
  methods: {
    /**
     * Check if item is open
     */
    checkIfItemIsOpen (item) {
      const index = this.open.findIndex(el => {
        return el === item
      })
      return index >= 0
    },
    /**
     * Toggle item from menu
     */
    toggleItem (item) {
      const index = this.open.findIndex(el => {
        return el === item
      })
      if (index < 0) this.open.push(item)
      else this.open.splice(index, 1)
    },
    /**
     * Toggle sidebar
     */
    toggleSidebar () {
      this.isSidebarClosed = !this.isSidebarClosed
      if (this.isSidebarClosed) {
        document.getElementById('kt_app_body').setAttribute('data-kt-app-sidebar-minimize', 'on')
      } else {
        document.getElementById('kt_app_body').removeAttribute('data-kt-app-sidebar-minimize')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-icon {
  fill:#c5c5d8;
}
#kt_app_sidebar_menu_wrapper {
  height: calc(100vh - 70px - 66px);
}

#kt_app_sidebar_footer {
  height: 66px;
}

</style>
